import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { Menu, BarChart2, Crown, History, LogOut } from 'lucide-react';
import { useAuth } from '../auth/useAuth';

function MobileNavItem({ icon, label, to, onClick }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        `w-full flex items-center gap-3 px-4 py-3.5 text-[14px] font-medium transition-all duration-200 ${
          isActive
            ? 'bg-[#faf5ff] text-[#9325e6]'
            : 'text-slate-600 hover:bg-gray-50'
        }`
      }
    >
      {React.cloneElement(icon, { className: 'w-[18px] h-[18px]' })}
      <span>{label}</span>
    </NavLink>
  );
}

export default function Topbar({ isMenuOpen, setIsMenuOpen }) {
  const location = useLocation();
  const { logout } = useAuth();
  
  let title = 'Account Overview';
  if (location.pathname === '/plans') title = 'Your Plans';
  if (location.pathname.startsWith('/history')) title = 'Payment History';

  return (
    <header className="flex justify-between items-center px-5 lg:px-10 py-3.5 lg:py-5 bg-[#fcfbff] sticky top-0 z-50 border-b border-gray-200/60 shrink-0">
      <div className="flex items-center gap-4 relative">
        <button 
          type="button"
          className="lg:hidden p-2 -ml-2 text-gray-600 hover:bg-purple-100/50 rounded-lg transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMenuOpen}
        >
          <Menu className="w-6 h-6" />
        </button>
        <div>
          <h2 className="text-[20px] lg:text-[24px] font-sans font-extrabold text-[#1a1e2e] tracking-tight">{title}</h2>
        </div>

        {/* Mobile Dropdown Menu */}
        {isMenuOpen && (
          <div className="absolute top-[100%] left-0 mt-3 w-[240px] bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.08)] border border-gray-100 flex flex-col lg:hidden overflow-hidden py-1">
            <MobileNavItem 
              to="/" 
              label="Overview" 
              icon={<BarChart2 />} 
              onClick={() => setIsMenuOpen(false)} 
            />
            <MobileNavItem 
              to="/plans" 
              label="Plans" 
              icon={<Crown />} 
              onClick={() => setIsMenuOpen(false)} 
            />
            <MobileNavItem 
              to="/history" 
              label="Payment History" 
              icon={<History />} 
              onClick={() => setIsMenuOpen(false)} 
            />
          </div>
        )}
      </div>
      <div className="flex items-center gap-3 lg:gap-4">
        <div className="w-8 h-8 lg:w-9 lg:h-9 rounded-full bg-[#f3e8ff] flex items-center justify-center text-[#9325e6] font-bold text-xs shadow-sm cursor-pointer hover:bg-purple-200 transition-colors shrink-0">
          A
        </div>
        <button
          type="button"
          onClick={logout}
          className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-purple-100 hover:text-[#7c3aed] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7c3aed] lg:hidden"
          aria-label="Log out"
        >
          <LogOut className="h-[18px] w-[18px]" aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
